import React from "react";
import Header from "../../Components/Header/Header";
import TrendingSlider from "../../Components/Carousel/trendingSlider";
import GardeningSlider from "../../Components/Carousel/gardeningSlider";
import PlantSlider from "../../Components/Carousel/plantSlider";
import OfferSlider from "../../Components/Carousel/OfferSlider";
import BulbSlider from "../../Components/Carousel/bulbSlider";
import PebbleSlider from "../../Components/Carousel/pebbleSlider";
import PotSlider from "../../Components/Carousel/potSlider";
import SeedSlider from "../../Components/Carousel/seedSlider";
import AccessorySlider from "../../Components/Carousel/accessorySlider";
import SoilAndFertilizerSlider from "../../Components/Carousel/soilfertSlider";
import CategoryBox from "../../Components/Category/CategoryBox";
import Footer from "../../Components/Footer/Footer";
import { categoryData } from "../../Components/data";
import "./Home.css";
const HomePage = () => {
  const mystyle = {
    color: "#61b76e",
  };
  const category = categoryData.map((item) => (
    <CategoryBox title={item.title} key={item.id} content={item.content} />
  ));

  return (
    <div>
      <Header />

      <OfferSlider />

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          TRENDING
        </h2>
        <TrendingSlider />
      </div>

      <div className="category_section">
        <h1>CATEGORIES TO BAG</h1>
        <main className="page-content">{category}</main>
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          GARDENING
        </h2>
        <GardeningSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          PLANTS
        </h2>
        <PlantSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          SEEDS
        </h2>
        <SeedSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          BULBS
        </h2>
        <BulbSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          POTS
        </h2>
        <PotSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          SOIL & FERTILIZER
        </h2>
        <SoilAndFertilizerSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          PEBBLES
        </h2>
        <PebbleSlider />
      </div>

      <div className="Bestsellers">
        <h2 style={mystyle}>
          <img
            className="BestImg"
            src="https://www.ugaoo.com/cdn/shop/files/Bestseller-1_2x_9a883cf1-58ba-4c74-badf-f02924575b68_small.png?v=1656416175"
            alt=""
          />
          ACCESSORIES
        </h2>
        <AccessorySlider />
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
